<template>
  <div class="publish-dynamic">
    <div class="publish-cont">
      <label>添加链接</label>
      <input type="text" v-model="title" placeholder="目前仅支持微信文章链接，每日上限为3次。" />
    </div>
    <div class="save-btn">
      <div class="btn-list active" @click="senseWord">发布</div>
      <!-- <div class="btn-list">保存草稿</div>
      <div class="btn-list">客户端浏览</div>-->
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import { log } from "util";
export default {
  // name: "App",
  data() {
    return {
      title: "",
      coverImg: require("../../assets/img/cover.png"),
      loadNum: "",
      content: "",
      videoUrl: "",
      se: [],
      sensi: [],
      keys: [],
      loading: false,
      editor: null,
      duration: "",
      number: 0
    };
  },
  mounted() {
    this.getPublishSum();
  },
  methods: {
    getPublishSum() {
      this.$http
        .get("/api/media/015-getPublishSum", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.number = res.data.rows[0].zhaopinCount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    senseWord() {
      if (this.number >= 3) {
        this.$message("文章链接,每日上限为3次哦~");
        return false;
      }
      //敏感词汇
      this.se = [];
      this.sensi = [];
      this.keys = [];
      this.$http
        .get("/api/media/012--sensitivewordList", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            var self = this;
            $.each(res.data.rows, function(k, v) {
              self.se.push(self.title.indexOf(v.keyWord));
              self.sensi.push(self.content.indexOf(v.keyWord));
            });
            if (self.se.indexOf(0) != -1 || self.sensi.indexOf(0) != -1) {
              this.$message("很抱歉,您发布的内容含有敏感词汇,无法上传");
            } else {
              this.pub();
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    pub() {
      //发布
      if (this.title == "") {
        this.$message("链接不能为空");
        return false;
      }
      this.$http
        .post("/api/core/saveArctileByWXUrl", {
          token: this.$store.state.userInfo.token,
          articleUrl: this.title,
        })
        .then(res => {
          // console.log(res, "发布");
          if (res.data.code == 0) {
            this.$message("发布成功");
            this.title = "";
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
#input {
  display: none;
}
.publish .btn-list {
  margin: 0px auto;
  float: none;
}

.kr-layout .kr-layout-main .main-right .kr-layout-content {
  min-height: 0px;
}
.publish .publish-cont {
  padding-left: 30px;
  margin-bottom: 10px;
}
.publish .publish-cont textarea {
  border: none;
  padding: 17px 10px;
  height: 100%;
}
.publish .publish-cont.intro {
  height: 400px;
  position: relative;
}
.publish .publish-cont.intro:after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: #ededed;
  position: absolute;
  bottom: 0px;
  left: 40px;
  right: 0px;
}
.publish .publish-cont .video-img {
  max-width: 240px;
  max-height: 160px;
  clear: both;
  margin-left: 90px;
  line-height: 0px;
}

.publish .zhuanti {
  padding-left: 40px;
}
.loading {
  width: 200px;
  height: 200px;
  float: left;
  position: absolute;
  left: 50%;
  top: 40%;
  margin: -100px 0px 0px -100px;
}
.publish .publish-cont .upload-video{color:#666}
.publish .publish-cont .video-img{width:240px;height:160px;}
</style>
<style>
.el-loading-spinner i {
  color: #2e8043 !important;
  font-size: 50px !important;
}
.el-loading-mask {
  border-radius: 6px;
}
.el-loading-spinner {
  top: 35% !important;
}
.el-loading-spinner .el-loading-text {
  text-align: center;
  font-size: 16px !important;
  color: #2e8043 !important;
  margin: 15px auto !important;
}
</style>
